import { render, staticRenderFns } from "./ServiceProviderBillingDetails.vue?vue&type=template&id=2b2b25e1&scoped=true"
import script from "./ServiceProviderBillingDetails.vue?vue&type=script&lang=js"
export * from "./ServiceProviderBillingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b25e1",
  null
  
)

export default component.exports